import { mdiSineWave } from '@mdi/js'

export default [
  {
    title: 'آنالیز',
    icon: mdiSineWave,
    action: 'can_see_analyze_menu',
    resource: 'all',
    children: [
      {
        title: 'ARPU',
        to: 'report-revenue',
        action: 'can_see_analyze_menu',
        resource: 'all',
      },
      {
        title: 'نرخ ریزش',
        to: 'report-churn',
        action: 'can_see_analyze_menu',
        resource: 'all',
      },
      {
        title: 'پرداختی‌ها و کاربران',
        to: 'report-payments-users',
        action: 'can_see_analyze_menu',
        resource: 'all',
      },
    ],
  },
]
